<template>
    <div class="side-bar" :class="{ hidden: !expanded }">
        <div class="side-bar-body">
            <router-link
                class="side-bar-option"
                :class="{ selected: page === 'overview' }"
                :title="$t('Overview')"
                :to="{ name: 'overview' }"
            >
                <div class="side-bar-option-icon"><i class="fas fa-solar-panel"></i></div>
                <div class="side-bar-option-text">{{ $t("Overview") }}</div>
            </router-link>

            <router-link
                class="side-bar-option"
                :class="{ selected: page === 'energy-flow' }"
                :title="$t('Energy flow')"
                :to="{ name: 'energy-flow' }"
            >
                <div class="side-bar-option-icon"><i class="fas fa-bolt"></i></div>
                <div class="side-bar-option-text">{{ $t("Energy flow") }}</div>
            </router-link>

            <router-link class="side-bar-option" :class="{ selected: page === 'storage' }" :title="$t('Storage')" :to="{ name: 'storage' }">
                <div class="side-bar-option-icon"><i class="fas fa-battery-full"></i></div>
                <div class="side-bar-option-text">{{ $t("Storage") }}</div>
            </router-link>

            <router-link class="side-bar-option" :class="{ selected: page === 'events' }" :title="$t('Events')" :to="{ name: 'events' }">
                <div class="side-bar-option-icon"><i class="fas fa-calendar-alt"></i></div>
                <div class="side-bar-option-text">{{ $t("Events") }}</div>
            </router-link>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useVModel } from "@/utils/v-model.ts";

export default defineComponent({
    components: {},
    name: "MenuSideBar",
    emits: ["update:expanded"],
    props: {
        expanded: Boolean,
    },
    setup(props) {
        return {
            expandedStatus: useVModel(props, "expanded"),
        };
    },
    data: function () {
        return {
            page: "",
        };
    },
    methods: {
        updatePage: function () {
            this.page = this.$route ? (this.$route.name as string) : "";
        },

        onAuthChanged: function () {},
    },
    mounted: function () {
        this.updatePage();

        this.$listenOnAppEvent("auth-status-changed", this.onAuthChanged.bind(this));
    },
    watch: {
        $route: function () {
            this.updatePage();
        },
    },
});
</script>

<style></style>
